import { useQuery } from "@tanstack/react-query";
import type { DashboardDto } from "@audit-plan/shared";
import { api } from "./client";

export interface DashFilter {
  year?: number;
  supplierId?: string;
  risk?: string;
}
export const useDashboard = (f: DashFilter) => useQuery({ queryKey: ["dashboard", f], queryFn: () => api.get<DashboardDto>("/dashboard", f as Record<string, string | number>) });
